/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2022-04-06 14:45:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/router/home/market.js
 */
// market
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')

// const MqlMiddlePage = () =>
//   import(/* webpackChunkName: 'memberList' */ '@components/core/MqlLayout/MqlMiddlePage/index')
const marketApps = () =>
  import(/* webpackChunkName: 'marketApps' */ '@views/home/market/marketApps/index')
const wechatpp = () =>
  import(/* webpackChunkName: 'marketApps' */ '@views/home/market/wechatpp/index')

// const activity= () =>
//     import(/* webpackChunkName: 'marketApps' */ "@views/home/market/activity/index");

const routes = [
  {
    path: '/market',
    component: index,
    redirect: { name: 'homeMarketApps' },
    name: 'market',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '营销应用',
      icon: 'market_apps',
      first: true,
      resourceCode: 'MARKET_APPS',
      No: 6
    },
    children: [
      {
        path: 'apps',
        component: marketApps,
        name: 'homeMarketApps',
        meta: {
          keepAlive: true,
          title: '营销应用',
          second: false,
          // resourceCode: "MARKET_APPS01",
          No: 0
        }
      },
      {
        path: 'wechatpp',
        component: wechatpp,
        name: 'wechatpp',
        meta: {
          keepAlive: true,
          title: '微信公众号',
          second: false,
          resourceCode: 'MARKET_APPS01',
          No: 1
        }
      },
      {
        path: 'rouse',
        component: () => import('@views/home/market/rouse/index'),
        name: 'rouse',
        meta: {
          keepAlive: true,
          title: '顾客唤醒',
          second: false,
          resourceCode: 'MARKET_APPS04',
          No: 4
        }
      },
      {
        path: 'blockette',
        component: () => import('@views/home/market/blockette/index'),
        name: 'blockette',
        meta: {
          keepAlive: true,
          title: '预约小程序功能',
          second: false,
          resourceCode: 'MARKET_APPS03',
          No: 3
        }
      },
      {
        path: 'activity',
        component: () => import('@views/home/market/activity/index'),
        name: 'activity',
        meta: {
          keepAlive: true,
          title: '活动推送',
          second: false,
          resourceCode: 'MARKET_APPS02',
          No: 2
        }
      },
      {
        path: 'statistics',
        component: () => import('@views/home/market/statistics/index'),
        name: 'statistics',
        meta: {
          keepAlive: true,
          title: '活动推送统计',
          second: false,
          resourceCode: '',
          No: ''
        }
      },
      {
        path: 'smsPush',
        component: () => import('@views/home/market/smsPush/index'),
        name: 'smsPush',
        redirect: 'smsPush/texting', // 配置子路由默认显示
        meta: {
          keepAlive: true,
          title: '短信营销包',
          second: false,
          resourceCode: '',
          No: 5
        },
        children: [
          {
            path: 'texting',
            component: () => import('@views/home/market/smsPush/components/texting/index'),
            name: 'texting',
            redirect: 'texting/sendGroupMessage',
            children: [
              {
                path: 'sendGroupMessage',
                component: () =>
                  import('@views/home/market/smsPush/components/texting/components/sendGroupMessage/index'),
                name: 'sendGroupMessage'
              },
              {
                path: 'consumerSMS',
                component: () =>
                  import('@views/home/market/smsPush/components/texting/components/consumerSMS/index'),
                name: 'consumerSMS'
              },
              {
                path: 'timedSMS',
                component: () =>
                  import('@views/home/market/smsPush/components/texting/components/timedSMS/index'),
                name: 'timedSMS'
              }
            ]
          },
          {
            path: 'smsPackage',
            component: () => import('@views/home/market/smsPush/components/smsPackage/index'),
            name: 'smsPackage'
          },

          {
            path: 'smsLibrary',
            component: () => import('@views/home/market/smsPush/components/smsLibrary/index'),
            name: 'smsLibrary'
          },
          {
            path: 'sendRecord',
            component: () => import('@views/home/market/smsPush/components/sendRecord/index'),
            name: 'sendRecord'
          },
          {
            path: 'messageSendingSettings',
            component: () =>
              import('@views/home/market/smsPush/components/messageSendingSettings/index'),
            name: 'messageSendingSettings'
          }
        ]
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/market.js